import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GfMeetingService } from '../gf-meeting.service';

import * as _ from 'lodash';
import * as $ from 'jquery';

@Component({
    selector: 'gf-meet-button',
    template: require('./gf-meet-button.component.html')
})
export class MeetButtonComponent implements OnInit {

    @Input() threadId: any;
    protected providers: any = {};
    protected singleProvider: any;
    private selector: string;
    protected clipboarded: boolean = false;
    protected chatPosted: boolean = false;
    protected meeting: any = null;

    constructor(
        private gfMeetingService: GfMeetingService,
        private httpClient: HttpClient
    ) {}
    
    ngOnInit() {
        this.providers = this.gfMeetingService.getProviders();
        this.singleProvider = _.keys(this.providers).length == 1 ?
            this.providers[_.keys(this.providers)[0]] : false;
    }

    copyToClipboard($event) {
        this.gfMeetingService.copyToClipboard($event.target);
        this.clipboarded = true;
    }

    showMeetingPrompt(meeting) {
        this.clipboarded = false;
        this.chatPosted = false;
        this.meeting = meeting;

        var elem: any = $(this.selector);
        elem.modal('show');
    }

    postMeetingNotice(meeting) {
        var params = {
            forumThread: this.threadId,
            subject: "Chat Message",
            body: meeting.joinUrl
        };
        this.httpClient.post(
            '/api/forummessage', params
        ).toPromise();
        this.chatPosted = true;
    }

    startMeeting(provider) {
        if (!this.selector) {
            this.selector = "#startMeetingModal-" + this.threadId;

            // Re-parent the modal so it's positioned and z-ordered relative to the body
            // Because the chat footer uses fixed positioning (see .navbar-fixed-top, .navbar-fixed-bottom)
            // the modal doesn't show properly
            // See also https://stackoverflow.com/a/15780841/151796
            $(this.selector).appendTo("body");
        }

        this.gfMeetingService.createMeeting(provider).then(
            (meeting) => { this.showMeetingPrompt(meeting); },
            (result) => console.log(result)
        );
    }
}
